"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
// This file is autogenerated by "make react_icons", do not edit it.
const React = tslib_1.__importStar(require("react"));
const Table = (props) => React.createElement("svg", { className: "lucide lucide-table", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", ...props },
    React.createElement("path", { d: "M12 3v18" }),
    React.createElement("rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }),
    React.createElement("path", { d: "M3 9h18M3 15h18" }));
exports.default = Table;
